import axios from 'axios'

import { userCredential } from '@/global'

const success = res => res

const error = err => {
    if (401 === err.response.status) {
        localStorage.removeItem(userCredential)
        // redirect pra "/" vai pra auth
        window.location = '/'
    } else {
        return Promise.reject(err)
    }
}

axios.interceptors.response.use(success, error)